export const STATUS_RECEIVE = Object.freeze({
	ACTIVE: "Em Aberto",
	PAID: "Pago",
	CANCELED: "Cancelado",
	RENEGOTIATED: "Renegociada",
	FINISHED: "Finalizado"
});

export const MONTHS = Object.freeze({
	JANEIRO: "1",
	FEVEREIRO: "2",
	MARÇO: "3",
	ABRIL: "4",
	MAIO: "5",
	JUNHO: "6",
	JULHO: "7",
	AGOSTO: "8",
	SETEMBRO: "9",
	OUTUBRO: "10",
	NOVEMBRO: "11",
	DEZEMBRO: "12"
});

export const TRANSACTIONS_TYPE = Object.freeze({
	INCOME: "Entrada",
	EXPENSES: "Saída",
	TRANSFER: "Transferência",
	TOPAY: "A Pagar",
	TORECEIVE: "A Receber",
	RECURRING: "Recurrente"
});

export const APP_STATUS_CODE = Object.freeze({
	ERR_RENEWAL_TOKEN: 401
});
